<modal *ngIf="show" [show]="show" [x]="false" (onClose)="onClose()" title="">
  <div class="wrapper text-center">
    <h3 class="modal-title" [class.text-danger]="style === ConfirmModalStyle.Danger" [class.text-success]="style === ConfirmModalStyle.Success">{{title}}</h3>
    <div class="img" *ngIf="style !== ConfirmModalStyle.None">
      <img src="assets/images/icons/{{style === ConfirmModalStyle.Success ? 'check' : 'danger'}}.svg" alt="">
    </div>
    <p class="text-gray">{{content}}</p>

    <div class="row g-0">
      <button *ngIf="no" class="col btn btn-outline" (click)="onClose()">{{no}}</button>
      <div class="col-auto p-2"></div>
      <button *ngIf="yes" class="col btn" [class.btn-danger]="style === ConfirmModalStyle.Danger" [class.btn-primary]="style !== ConfirmModalStyle.Danger" (click)="onConfirm()">{{yes}}</button>
    </div>
  </div>
</modal>